/* eslint-disable */

import H from "@here/maps-api-for-javascript";
import onResize from "simple-element-resize-detector";
import { getNextApiKey } from "../config/hereConfig";
import MapAdapter from "./MapAdapter";

// Implementação HERE Maps — comportamento original do app, preservado.
// Mantida para permitir reverter (flag MAP_PROVIDER='here').
export default class HereMapAdapter extends MapAdapter {
  constructor() {
    super();
    this.map = null;
    this.platform = null;
    this.router = null;
    this.markers = new Map(); // key -> H.map.Marker
    this.routeObjects = []; // objetos H.* da rota desenhada
    this._onViewChange = null;
    this._viewChangeHandler = null;
  }

  init({ container, center, zoom, onViewChange }) {
    this._onViewChange = onViewChange;

    this.platform = new H.service.Platform({
      apiKey: getNextApiKey(), // rotação de chaves da API
    });

    const layers = this.platform.createDefaultLayers();
    this.map = new H.Map(container, layers.vector.normal.map, {
      pixelRatio: window.devicePixelRatio,
      center,
      zoom,
    });

    this._viewChangeHandler = (ev) => {
      if (ev.newValue && ev.newValue.lookAt && this._onViewChange) {
        const lookAt = ev.newValue.lookAt;
        const lat = Math.trunc(lookAt.position.lat * 1e7) / 1e7;
        const lng = Math.trunc(lookAt.position.lng * 1e7) / 1e7;
        const z = Math.trunc(lookAt.zoom * 1e2) / 1e2;
        this._onViewChange(z, lat, lng);
      }
    };
    this.map.addEventListener("mapviewchange", this._viewChangeHandler);

    new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

    onResize(container, () => {
      this.map.getViewPort().resize();
    });

    H.ui.UI.createDefault(this.map, layers, "pt-BR");

    this.router = this.platform.getRoutingService(null, 8);
  }

  resize() {
    if (this.map) this.map.getViewPort().resize();
  }

  setView(lat, lng, zoom) {
    if (!this.map) return;
    this.map.setCenter({ lat, lng });
    if (zoom) this.map.setZoom(zoom);
  }

  destroy() {
    if (this.map && this._viewChangeHandler) {
      this.map.removeEventListener("mapviewchange", this._viewChangeHandler);
    }
  }

  get raw() {
    return this.map;
  }

  // ---- marcadores ----

  addMarker(key, lat, lng, svg, opts = {}) {
    const icon = new H.map.Icon(svg);
    const marker = new H.map.Marker(
      { lat, lng },
      { icon, data: key, zIndex: opts.zIndex }
    );
    if (opts.onTap) {
      marker.addEventListener("tap", () => opts.onTap());
    }
    this.map.addObject(marker);
    this.markers.set(key, marker);
    return marker;
  }

  hasMarker(key) {
    return this.markers.has(key);
  }

  getMarkerPosition(key) {
    const marker = this.markers.get(key);
    if (!marker) return null;
    const g = marker.getGeometry();
    return { lat: g.lat, lng: g.lng };
  }

  setMarkerPosition(key, lat, lng) {
    const marker = this.markers.get(key);
    if (marker) marker.setGeometry({ lat, lng });
  }

  setMarkerIcon(key, svg) {
    const marker = this.markers.get(key);
    if (marker) marker.setIcon(new H.map.Icon(svg));
  }

  removeMarker(key) {
    const marker = this.markers.get(key);
    if (marker) {
      this.map.removeObject(marker);
      this.markers.delete(key);
    }
  }

  getMarkerKeys() {
    return Array.from(this.markers.keys());
  }

  // ---- rotas ----

  showRoute({ origin, destination, via }) {
    if (!this.router) return Promise.resolve();

    const routingParameters = {
      origin,
      destination,
      via: new H.service.Url.MultiValueQueryParameter(via),
      routingMode: "fast",
      transportMode: "car",
      return: "polyline",
    };

    return new Promise((resolve) => {
      this.router.calculateRoute(
        routingParameters,
        (result) => {
          this._drawRoute(result);
          resolve();
        },
        (error) => {
          console.log(error.message);
          resolve();
        }
      );
    });
  }

  _drawRoute(result) {
    if (!result.routes.length) return;

    this.clearRoutes();

    result.routes[0].sections.forEach((section, idx, array) => {
      const linestring = H.geo.LineString.fromFlexiblePolyline(section.polyline);

      if (idx !== array.length - 1) {
        const routeOutline = new H.map.Polyline(linestring, {
          style: {
            lineWidth: 10,
            strokeColor: "rgba(0, 128, 255, 0.7)",
            lineTailCap: "arrow-tail",
            lineHeadCap: "arrow-head",
          },
        });
        const routeArrows = new H.map.Polyline(linestring, {
          style: {
            lineWidth: 10,
            fillColor: "white",
            strokeColor: "rgba(255, 255, 255, 1)",
            lineDash: [0, 2],
            lineTailCap: "arrow-tail",
            lineHeadCap: "arrow-head",
          },
        });
        const routeLine = new H.map.Group();
        routeLine.addObjects([routeOutline, routeArrows]);

        this.routeObjects.push(routeLine);
        this.map.addObject(routeLine);
      }
    });
  }

  clearRoutes() {
    if (this.routeObjects.length > 0) {
      this.map.removeObjects(this.routeObjects);
      this.routeObjects = [];
    }
  }

  // ---- geo ----

  distanceMeters(a, b) {
    return new H.geo.Point(a.lat, a.lng).distance(
      new H.geo.Point(b.lat, b.lng)
    );
  }
}
